import React from "react";
import Marquee from "react-fast-marquee";
import { graphql, useStaticQuery } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";

// Utils //
import { splitButtonText } from "../../../utils/helpers";

// Styles //
import "./companies-trust-us.scss";

const ComponiesTrustUs = (props: any) => {

    const {
        tituloGeneral,
        descripcion,
        tituloBoton,
        referenciaPlantillaContenido: Contenido,
    } = props;

    let introText = "";

    try {
        // Verifica si descripcion.raw es un string
        const descripcionData = typeof descripcion.raw === "string" ? JSON.parse(descripcion.raw) : descripcion.json;
        introText = descripcionData.content[0].content[0].value;
    } catch (error) {
        console.error("Error parsing JSON:", error);
    }

    return (
        <div className="companies-container">
            <div className="o-companies">
                <div className="o-companies__container">
                {tituloGeneral && 
                    <TitleSection
                        title={tituloGeneral}
                        introText={introText}
                    />
                }
                </div>
                <div className="o-companies__carousel">
                    <Marquee gradient={false} speed={25} data-testid="marquee">
                        <div
                            className="companies-slider"
                            style={{
                                width: `${
                                    (Contenido[0]?.imagenPrincipal?.length / 2) *
                                    180
                                }px`,
                            }}
                        >
                            {Contenido[0]?.imagenPrincipal?.map((image, i) => (
                                <div className="companies-slider__item" key={i}>
                                    <div className="companies-slider__image">
                                        <img
                                            src={image.file.url}
                                            alt={image.title}
                                            aria-label={image.title}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Marquee>
                </div>
                <div className="o-companies__buttons">
                    <Button
                        type="link"
                        text={splitButtonText(tituloBoton, 0)}
                        classname={`a-button__magenta gtmHomeClicButtonPersonas`}
                        href="./personas/"
                        isDisabled={false}
                    />
                    <Button
                        type="link"
                        text={splitButtonText(tituloBoton, 1)}
                        classname={`a-button__green gtmHomeClicButtonEmpresas`}
                        href="./empresas/"
                        isDisabled={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ComponiesTrustUs;
